import React from 'react';
import { BsCloudUpload as UploadIcon } from 'react-icons/bs';
import { Content, IconWrapper, Text, SubText, Wrapper } from './styled';

const ReportFileDropOverlay = () => (
  <Wrapper>
    <Content>
      <IconWrapper>
        <UploadIcon />
      </IconWrapper>
      <Text>Add vulnerabilities</Text>
      <SubText>Drop your report here</SubText>
    </Content>
  </Wrapper>
);

export default ReportFileDropOverlay;
